export default __webpack_public_path__ + "static/media/acrepairguy3.4e21488c.webp";